import { configureStore } from '@reduxjs/toolkit';
import { modelReducer } from './ModelReducer';
import { miscReducer } from './MiscReducer';
import { toolReducer } from './ToolReducer';
import { userReducer } from './UserReducer';
import { currencyReducer } from './CurrencyReducer';
import { discountReducer } from './DiscountReducer';
import { ToolsOfferedReducer } from './ToolsOfferedReducer';
import { appReducer } from './AppReducer';
import { customerReducer } from './CustomerReducer';
import { reportReducer } from './ReportReducer';
import { DiscountsOfferedReducer } from './DiscountsOfferedReducer';

const allReducers = configureStore({
    reducer: {
        misc: miscReducer,
        model: modelReducer,
        tool: toolReducer,
        usersList: userReducer,
        currency : currencyReducer,
        discount : discountReducer,
        toolOffered: ToolsOfferedReducer,
        loggedInUserInfo: appReducer,
        customersList: customerReducer,
        reportsList:reportReducer,
        discountList: DiscountsOfferedReducer,
    }
})

export default allReducers